"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _SseKmsEncryptedObjects_1 = require("./_SseKmsEncryptedObjects");
exports._SourceSelectionCriteria = {
    type: "structure",
    required: [],
    members: {
        SseKmsEncryptedObjects: {
            shape: _SseKmsEncryptedObjects_1._SseKmsEncryptedObjects
        }
    }
};
//# sourceMappingURL=_SourceSelectionCriteria.js.map